__turbopack_context__.v({
  "accommodationBody": "AccommodationCard-module__jmGn7W__accommodationBody",
  "accommodationCard": "AccommodationCard-module__jmGn7W__accommodationCard",
  "accommodationImage": "AccommodationCard-module__jmGn7W__accommodationImage",
  "accommodationImageWrap": "AccommodationCard-module__jmGn7W__accommodationImageWrap",
  "accommodationTitle": "AccommodationCard-module__jmGn7W__accommodationTitle",
  "viewDetailBtn": "AccommodationCard-module__jmGn7W__viewDetailBtn",
});
